import BasePath from "./BasePath";
import AuthorizedPath from "./AuthorizedPath";

export default {
    login: new BasePath("#0/authentication/v1/#1"),
    createApplication: new AuthorizedPath("#0/#1/#2/applications"),
    createApplicationProd: new AuthorizedPath("#1/#2/applications")
};
